import {
  Calendar,
  Database,
  Users,
  MessageCircle,
  MessageSquare,
  Mail,
  Phone,
  FileText,
  ListChecks,
  CalendarPlus,
  Info,
} from "lucide-react";

const INTEGRATIONS = [
  { icon: Calendar, label: "Calendarios" },
  { icon: Database, label: "Software de gestión dental" },
  { icon: Users, label: "CRM" },
  { icon: MessageCircle, label: "WhatsApp" },
  { icon: MessageSquare, label: "SMS" },
  { icon: Mail, label: "Email" },
  { icon: Phone, label: "Telefonía automática" },
  { icon: FileText, label: "Formularios web" },
  { icon: ListChecks, label: "Lista de espera" },
  { icon: CalendarPlus, label: "Sistemas de reservas" },
];

export default function Integrations() {
  return (
    <section id="integraciones" className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-semibold uppercase tracking-widest text-navy-light">
            Integraciones
          </p>
          <h2
            data-testid="integrations-title"
            className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-navy sm:text-4xl"
          >
            Funciona con el ecosistema de tu clínica.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-steel sm:text-lg">
            Evaluamos tu software actual y definimos la conexión más adecuada para tu
            clínica.
          </p>
        </div>

        <div className="mx-auto mt-12 grid max-w-4xl grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {INTEGRATIONS.map((item) => (
            <div
              key={item.label}
              data-testid={`integration-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="flex flex-col items-center gap-3 rounded-xl border border-[#E8EDF5] bg-platinum/50 px-4 py-6 text-center transition-all duration-200 hover:-translate-y-1 hover:bg-white hover:shadow-md"
            >
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-navy/[0.06]">
                <item.icon className="h-5 w-5 text-navy" strokeWidth={1.8} />
              </div>
              <span className="text-xs font-semibold leading-tight text-navy sm:text-sm">
                {item.label}
              </span>
            </div>
          ))}
        </div>

        <p className="mx-auto mt-10 flex max-w-2xl items-start justify-center gap-2 text-center text-xs leading-relaxed text-steel">
          <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-navy-light" />
          La disponibilidad de cada integración depende del software utilizado, sus
          permisos y sus posibilidades técnicas.
        </p>
      </div>
    </section>
  );
}
